import { ILiquidation } from '@core/models/ILiquidation';
import { todayInRange } from '@core/utils/date.util';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';

export class LiquidationModel {
  public id: number;
  public name: string;
  public url: string;
  public showProductsOnPendingStatus: boolean;
  public idProducts: number[];
  private _status: BehaviorSubject<string> = new BehaviorSubject<string>('hide');

  get status$(): Observable<string> {
    return this._status.asObservable();
  }

  status(): string {
    return this._status.getValue();
  }

  setStatus(newStatus: string): void {
    this._status.next(newStatus);
  }
  public images: {
    banner: string | null;
    large: string | null;
    medium: string | null;
    small: string | null;
  };
  private timerSubscription: Subscription | null = null;
  public liquidationTimer: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public onSelected: (idLiquidacion: number) => boolean;
  public showProductsOrValidity: boolean;
  constructor(data: ILiquidation) {
    this.id = data.id;
    this.name = data.nombre;
    this.url = data.url;
    this.images = data.imagenes;
    this.idProducts = data.idProductos;
    this.showProductsOnPendingStatus = data.mostrarProductosEnWeb;
    this.updateStatus(data);
    this.startTimer(data);
  }

  private updateStatus(data: ILiquidation): void {
    const hoy = new Date();
    if (todayInRange(hoy, new Date(data.mostrarEnWebDesde), new Date(data.hasta))) {
      if (hoy >= new Date(data.desde)) {
        const differenceUntil = new Date(data.hasta).getTime() - hoy.getTime();
        if (differenceUntil > 0) {
          this.liquidationTimer.next(`${this.getTimeDifference(differenceUntil)}`);
          this.setStatus('active');
        } else {
          this.liquidationTimer.next('La liquidación finalizó');
          this.setStatus('ended');
          this.stopTimer();
        }
      } else {
        this.setStatus('pending');
        const differenceSince = new Date(data.desde).getTime() - hoy.getTime();
        this.liquidationTimer.next(`${this.getTimeDifference(differenceSince)}`);
      }
    } else {
      this.setStatus('hide');
    }

    this.showProductsOrValidity =
      this.status() == 'active' || (this.status() == 'pending' && this.showProductsOnPendingStatus);
  }

  private startTimer(data: ILiquidation): void {
    this.stopTimer();
    this.timerSubscription = interval(60000).subscribe(() => {
      this.updateStatus(data);
    });
  }

  private getTimeDifference(difference: number): string {
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

    return `${days} días ${hours}hs ${mins}min`;
  }

  public stopTimer(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
  public isSelected(): boolean {
    if (this.onSelected) {
      return this.onSelected(this.id);
    }
    return false;
  }
}
